// const path = require('path');

export default (filePath = '@/page/account/components') => {
  let modules = {};
  if (filePath) {
    const files = require.context('@/page/account/components', false, /\.vue$/);
    files.keys().forEach(fileName => {
      modules[fileName.replace(/(^\.\/)|(\.vue$)/g, '')] = files(
        fileName
      ).default;
    });
  }
  return modules;
};
